import { giphyCharcoal, giphyLightestGrey } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { VerifiedBadgeIcon } from 'ui/src/icons/ui'
import { borderRadiusFromControlSize, fontSizeFromControlSize, heightFromControlSize } from 'utils'
import AvatarComponent from '../avatar'

export const Active = styled.div`
    background: ${giphyCharcoal};
    border-radius: 2px;
    color: ${giphyLightestGrey};
    flex-shrink: 0;
    font-size: 0.75em;
    font-weight: normal;
    margin: 0 4px 0 auto;
    padding: 0.2em 1em;
`

export const Avatar = styled(AvatarComponent)`
    flex-shrink: 0;
    margin-right: 0.3em;
`

export const Recent = styled.div<{ $size: ControlSize }>`
    align-items: center;
    cursor: pointer;
    display: flex;
    font-weight: bold;
    text-align: left;

    &:active {
        opacity: 0.9;
    }

    ${({ $size }) => css`
        border-radius: ${borderRadiusFromControlSize($size)}px;
        height: ${heightFromControlSize($size)}px;
        font-size: ${fontSizeFromControlSize($size)}px;
    `}
`

export const Recents = styled.div`
    padding: 10px 20px;
`

export const Username = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const Verified = styled(VerifiedBadgeIcon)`
    flex-shrink: 0;
    height: 16px;
    margin: 0 0.5em;
    width: 16px;
`
